(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    // Add to cart functionality
document.addEventListener('click', function(event) {
  if (event.target.matches('[data-add-to-cart]')) {
    const button = event.target;
    const variantId = button.dataset.variantId;

    // Disable button and show loading state
    button.disabled = true;
    const originalText = button.textContent;
    button.textContent = 'Adding...';

    // Add to cart via Shopify AJAX API
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      // Success - update cart count and show feedback
      const customEvent = new CustomEvent('cart:updated', {
        detail: { item_count: data.item_count || 0 }
      });
      document.dispatchEvent(customEvent);

      button.textContent = 'Added!';
      button.classList.remove('bg-primary', 'hover:bg-red-700');
      button.classList.add('bg-green-600');

      // Reset button after 2 seconds
      setTimeout(() => {
        button.textContent = originalText;
        button.classList.remove('bg-green-600');
        button.classList.add('bg-primary', 'hover:bg-red-700');
        button.disabled = false;
      }, 2000);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      button.textContent = 'Error - Try Again';
      button.disabled = false;

      // Reset button after 2 seconds
      setTimeout(() => {
        button.textContent = originalText;
      }, 2000);
    });
  }
});
  } catch(e) { console.error(e); }
})();

})();
